// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_l1-1";
export var rowFirst = "_l1-3";
export var rowLast = "_l1-5";
export var rowMiddle = "_l1-4";
export var ticketListScroll = "_l1-2";
export var ticketStack = "_l1-0";